function TextIcon({
  size = 36,
  className = '',
  onClick = (event) => {}
}: {
  size?: number;
  className?: string;
  onClick?: (event) => void;
}) {
  return (
    <span className={className} onClick={onClick}>
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width={size}
        height={size}
        viewBox='0 0 16 16'
        fill='none'
      >
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M1.33331 11.3333C1.33331 10.9651 1.63179 10.6667 1.99998 10.6667H11.3333C11.7015 10.6667 12 10.9651 12 11.3333C12 11.7015 11.7015 12 11.3333 12H1.99998C1.63179 12 1.33331 11.7015 1.33331 11.3333Z'
          fill='currentColor'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M1.33331 7.99999C1.33331 7.63181 1.63179 7.33333 1.99998 7.33333H14C14.3682 7.33333 14.6666 7.63181 14.6666 7.99999C14.6666 8.36818 14.3682 8.66666 14 8.66666H1.99998C1.63179 8.66666 1.33331 8.36818 1.33331 7.99999Z'
          fill='currentColor'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M1.33331 4.66667C1.33331 4.29848 1.63179 4 1.99998 4H14C14.3682 4 14.6666 4.29848 14.6666 4.66667C14.6666 5.03486 14.3682 5.33333 14 5.33333H1.99998C1.63179 5.33333 1.33331 5.03486 1.33331 4.66667Z'
          fill='currentColor'
        />
      </svg>
    </span>
  );
}

export default TextIcon;
